import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Download, MailOpen } from "lucide-react";
import api from "@/lib/api";

function fmt(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export default function AdminInbox({ mode }) {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const load = () => {
    if (mode === "mensagens") api.get("/admin/messages").then((r) => setItems(r.data || [])).catch(() => {});
    else api.get("/admin/applications").then((r) => setItems(r.data || [])).catch(() => {});
  };
  useEffect(() => {
    load();
  }, [mode]);

  const markRead = async (m) => {
    try {
      await api.patch(`/admin/messages/${m.id}`, { read: true });
      load();
    } catch (e) {}
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/${mode === "mensagens" ? "messages" : "applications"}/${id}`);
      toast.success("Registro excluído.");
      load();
    } catch (e) {
      toast.error("Não foi possível excluir.");
    }
  };

  const download = async (a) => {
    try {
      const resp = await api.get(`/admin/applications/${a.id}/resume`, { responseType: "blob" });
      const url = URL.createObjectURL(resp.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = a.resume_name || "curriculo";
      link.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Não foi possível baixar o currículo.");
    }
  };

  return (
    <div data-testid={`admin-${mode}`}>
      <h1 className="font-display text-3xl text-navy">{mode === "mensagens" ? "Mensagens recebidas" : "Currículos recebidos"}</h1>
      <p className="mt-2 text-sm text-inkgray">
        {mode === "mensagens"
          ? "Mensagens enviadas pelo formulário de contato do site."
          : "Candidaturas enviadas pela página Faça Parte. Acesso restrito."}
      </p>

      <div className="mt-8 space-y-4">
        {items.length === 0 && (
          <p className="border border-dashed border-navy/20 bg-white px-6 py-10 text-sm text-inkgray" data-testid={`admin-${mode}-empty`}>
            {mode === "mensagens" ? "Nenhuma mensagem recebida ainda." : "Nenhuma candidatura recebida ainda."}
          </p>
        )}
        {items.map((item) => {
          const open = expanded === item.id;
          const unread = mode === "mensagens" && !item.read;
          return (
            <div key={item.id} className={`border bg-white p-5 ${unread ? "border-gold" : "border-navy/10"}`} data-testid={`admin-${mode}-item-${item.id}`}>
              <button
                className="flex w-full flex-col justify-between gap-2 text-left md:flex-row md:items-center"
                data-testid={`admin-${mode}-toggle-${item.id}`}
                onClick={() => {
                  setExpanded(open ? null : item.id);
                  if (mode === "mensagens" && unread) markRead(item);
                }}
              >
                <div>
                  <p className="font-semibold text-navy">
                    {item.name} {unread && <span className="ml-2 inline-block h-2 w-2 rounded-full bg-gold align-middle" aria-hidden="true" />}
                  </p>
                  <p className="mt-1 text-xs text-inkgray">
                    {mode === "mensagens" ? item.subject : item.area} · {item.email} · {item.phone}
                  </p>
                </div>
                <p className="text-xs text-inkgray/60">{fmt(item.created_at)}</p>
              </button>

              {open && (
                <div className="mt-4 border-t border-navy/10 pt-4" data-testid={`admin-${mode}-detail-${item.id}`}>
                  {mode === "mensagens" ? (
                    <p className="whitespace-pre-line text-sm leading-relaxed text-inkgray">{item.message}</p>
                  ) : (
                    <>
                      {item.presentation && <p className="whitespace-pre-line text-sm leading-relaxed text-inkgray">{item.presentation}</p>}
                      <div className="mt-4 flex flex-wrap gap-3">
                        <button
                          data-testid={`admin-curriculo-download-${item.id}`}
                          onClick={() => download(item)}
                          className="inline-flex items-center gap-2 border border-navy/20 px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.16em] text-navy hover:border-gold"
                        >
                          <Download size={13} /> Baixar currículo
                        </button>
                        <span className="inline-flex items-center text-xs text-inkgray/60">
                          <MailOpen size={13} className="mr-1.5 text-gold-deep" /> {item.resume_name}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              )}

              <div className="mt-4 flex justify-end">
                <button data-testid={`admin-${mode}-delete-${item.id}`} onClick={() => remove(item.id)} className="flex items-center gap-2 border border-red-200 px-3.5 py-2 text-[10px] font-bold uppercase tracking-[0.16em] text-red-600 hover:bg-red-50">
                  <Trash2 size={12} /> Excluir
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
